module.exports = __webpack_public_path__ + "img/mc_logo.314edaf8.png";